import BaseSelectBox from 'components/atoms/base-select-box';
import { useMemo, type FC } from 'react';
import { followUpCompletedDataSource } from 'infrastructure/data-sources/followup-completed';

import type { IFollowUpCompletedItem } from 'infrastructure/data-sources/followup-completed';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IFollowUpCompletedItem['id'],
  IFollowUpCompletedItem
>[];

interface FollowUpCompletedSelectBoxProps
  extends Omit<IBaseSelectBoxProps<IFollowUpCompletedItem['id']>, 'options'> {
  withNone?: boolean;
}

export const FollowUpCompletedSelectBox: FC<FollowUpCompletedSelectBoxProps> = (
  props,
) => {
  const { withNone = true } = props;
  const dataSource = useMemo(
    () => followUpCompletedDataSource(withNone),
    [withNone],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};
